import { render, staticRenderFns } from "./1-5.AddPremium.vue?vue&type=template&id=475cfaae&scoped=true"
import script from "./1-5.AddPremium.vue?vue&type=script&lang=js"
export * from "./1-5.AddPremium.vue?vue&type=script&lang=js"
import style0 from "./1-5.AddPremium.vue?vue&type=style&index=0&id=475cfaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475cfaae",
  null
  
)

export default component.exports